export default __webpack_public_path__ + "static/media/p-22.12fea355.svg";